<!-- Sidebar -->
<app-sidebar></app-sidebar>
<div>
  <app-header></app-header>
  <div class="action-header" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
    <div fxFlex="70%">
      <button mat-button *ngIf="tipoOperacao !== 1" class="cancel-button" (click)="visualizarStatus()">HISTÓRICO PROTOCOLO</button>
      <button mat-stroked-button color="warn" *ngIf="protocolo.codigoSistema !== 1 && tipoOperacao !== 1 && isProtocoloTerceiros()" class="cancel-button" (click)="aprovarDocumento()">APROVAR DOCUMENTO</button>
      <button mat-button *ngIf="protocolo.codigoSistema !== 1 && habilitaBotaoCancelar()" class="cancel-button" (click)="cancelarProtocolo($event)">CANCELAR PROTOCOLO</button>
      <button mat-button class="extra-large btn-elevantion" id="btnSalvarProtocolo" *ngIf="protocolo.codigoSistema !== 1 && tipoOperacao !== 2" [disabled]="desabilitarBotaoSalvar()" (click)="validarProtocolo()">SALVAR PROTOCOLO</button>
      <button mat-button color="primary" class="btn-primary extra-large" *ngIf="protocolo.codigoSistema !== 1 && tipoOperacao === 2" (click)="habilitarModoEdicao()">EDITAR PROTOCOLO</button>
    </div>
    <div *ngIf="tipoOperacao !== 1" fxFlex="30%">
      <div class="float-left">
        <span class="action-protocolo" id="idProtocolo">PROTOCOLO: </span> <span class="margin-rigth action-protocolo">{{protocolo.idProtocolo}}</span>
      </div>
      <div class="float-left">
        <mat-icon class="icon action-protocolo" (click)="openAll()">add_circle</mat-icon>
      </div>
      <div >
        <mat-icon class="icon action-protocolo" (click)="closeAll()">remove_circle</mat-icon>
      </div>
    </div>
  </div>
  <!-- Page Content -->
  <div id="content">
    <!--Acão-->
    <div class="action-body">
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <!-- Cabeçalho-->
        <mat-expansion-panel class="expansion-panel" [expanded]="this.etapaAtual === 0" #mep="matExpansionPanel" (opened)="cabecalhoInnit()">
          <br />
         <p><label *ngIf="tipoOperacao !== 2" class="mat-h2">Selecione o tipo de Documento: </label></p>
          <br />
          <mat-expansion-panel-header>
            <mat-panel-title>
              1. Tipo de Documento: {{protocolo.descTipoDocumento}}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="tipoDocumentoForm">
            <div class="container" fxLayout="row" fxLayoutGap="0.5%" *ngIf="tipoOperacao !== 1">
              <mat-form-field class="select-disabled" fxFlex="35%" *ngIf="exibirStatusNovo()">
                <mat-select formControlName="frmStatusNovoProtocolo" placeholder="STATUS DO PROTOCOLO" [(ngModel)]="protocolo.idStatusNovo" disabled>
                  <mat-option *ngFor="let item of statusNovoProtocolo" [value]="item.value">
                    {{item.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="select-disabled" fxFlex="35%" *ngIf="!exibirStatusNovo()">
                <mat-select formControlName="frmStatusProtocolo" placeholder="STATUS DO PROTOCOLO" [(ngModel)]="protocolo.idStatusProtocolo" disabled>
                  <mat-option *ngFor="let item of statusProtocolo" [value]="item.value">
                    {{item.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="input-disabled" fxFlex="35%" *ngIf="protocolo.descricaoStatus !== ''">
                <input matInput readonly formControlName="frmDescricaoStatusProtocolo" [(ngModel)]="protocolo.descricaoStatus" value="{{protocolo.descricaoStatus}}" placeholder="DESCRIÇÃO STATUS">
              </mat-form-field>
              <mat-form-field class="select-disabled" fxFlex="30%">
                <mat-select formControlName="frmSistemas" placeholder="SISTEMA" [(ngModel)]="protocolo.codigoSistema" disabled>
                  <mat-option *ngFor="let item of sistemas" [value]="item.value">
                    {{item.viewValue}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="container" fxLayout="row" fxLayoutGap="0.5%" *ngIf="tipoOperacao !== 1">
              <mat-form-field class="input-disabled" fxFlex="100%" *ngIf="protocolo.motivoCancelamento">
                <input matInput readonly formControlName="frmStatusMotivo" [(ngModel)]="protocolo.motivoCancelamento" value="{{protocolo.motivoCancelamento}}" placeholder="MOTIVO / OBSERVAÇÃO">
              </mat-form-field>
            </div>
            <br />
            <div class="container" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%" fxLayoutAlign="center">
              <div>
                <div class="container" fxLayout="row">
                  <mat-card fxFlex="100%" class="mat-elevation-z0 ">
                    <img mat-card-image class="img img-small-max-width" src="../../../assets/images/imgNaoFiscal.PNG" alt="Imagem Código de Barras">
                    <mat-card-content class="card-content-text">
                      <h2>Fiscal</h2>
                    </mat-card-content>
                  </mat-card>
                </div>
                <div class="container comboTipoDocumento" fxLayout="row">
                  <mat-form-field style="width:100%">
                    <mat-select formControlName="frmTipoDoc" [(ngModel)]="protocolo.codTipoDocumento" (selectionChange)="onChangeTipoDocumento($event)" placeholder="Qual o tipo do documento" required>
                      <mat-option *ngFor="let tipoDoc of tipoDocs" [value]="tipoDoc.codTipoDocumento">
                        {{tipoDoc.tipoDocumento}}
                      </mat-option>
                      <mat-option *ngIf="protocolo.idTipoDocumento !== undefined && rpaUrbanais.codTipoDocumento == protocolo.idTipoDocumento.toString()" [value]="rpaUrbanais.codTipoDocumento">{{rpaUrbanais.tipoDocumento}}</mat-option>
                      <mat-option *ngIf="protocolo.idTipoDocumento !== undefined && rpa.codTipoDocumento == protocolo.idTipoDocumento.toString()" [value]="rpa.codTipoDocumento">{{rpa.tipoDocumento}}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="fTpDoc.frmTipoDoc.errors && fTpDoc.frmTipoDoc.errors.required">{{getErrorMessage()}}
                    </mat-error>
                  </mat-form-field>
                </div>
                <div *ngIf="tipoOperacao !== 2" class="container" fxLayout="row">
                  <form class="dropzone needsclick" id="demo-upload" action="/upload">
                    <div class="dz-message needsclick upload text-center">
                      <app-upload-fiscal></app-upload-fiscal>
                      <br />
                    </div>
                  </form>
                </div>
                <div fxLayout="row">
                  <mat-error *ngIf="fileUploadLenth && LstUploadFiles.length == 0 ">Necessário pelo menos um arquivo
                  </mat-error>
                </div>
              </div>
            </div>
            <div class="lista-upload">
              <mat-chip-list>
                <mat-chip class="pointer" *ngFor="let doc of LstUploadFiles" (click)="downloadImage(doc)">{{doc}}
                  <mat-icon *ngIf="this.protocolo.modoEdicao" class="check">check</mat-icon>
                  <mat-icon [class.disabled-action]="desativarIconDeleteUploadFile(doc)" class="delete-file" (click)="deleteFile(doc)">{{getIconDeleteFile(doc)}}</mat-icon>
                </mat-chip>
              </mat-chip-list>
            </div>
            <br />
            <mat-action-row class="footer">
              <button id="btnTipoDoc" mat-button color="primary" class="btn-primary" (click)="onSubmitTipoDoc()">CONTINUAR</button>
            </mat-action-row>
          </form>
        </mat-expansion-panel>
        <!-- Fim Cabeçalho-->

        <!--Ficha Protocolo-->
          <mat-expansion-panel class="expansion-panel" [expanded]="etapaAtual === 1" [disabled]="fichaProtocoloIsDisabled()" (opened)="fichaProtocoloInnit()">
            <mat-expansion-panel-header class="custom-header">
              <mat-panel-title>
                2. Ficha do Protocolo
              </mat-panel-title>
            </mat-expansion-panel-header>
            <form [formGroup]="fichaForm" #formDir="ngForm">
              <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
                <mat-form-field fxFlex="75%" *ngIf="this.protocolo.idTipoDocumento == 20">
                  <input [readonly]="apenasLeituraDanfe()" matInput placeholder="DANFE - CHAVE DE ACESSO/CÓDIGO DE BARRAS" formControlName="frmCodBarras" [(ngModel)]="protocolo.codBarras"(change)="onChangeDanfe()" [required]="ehFabricaDeKits('')"  >
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmCodBarras.errors && fFichaPro.frmCodBarras.errors.required">DANFE é Obrigatória
                  </mat-error>
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmCodBarras.errors && ehFabricaDeKits('')">DANFE é Obrigatória para protocolos referente a fábrica de kits
                  </mat-error>
                </mat-form-field>
                  <mat-form-field *ngIf="exibirCampoAprovador()" fxFlex="25%">
                    <mat-select #aprovadorSelect (blur)="limparErrorsInput('frmAprovador')" [disabled]="desabilitarAprovador()" [(ngModel)]="protocolo.nomeAprovador" [formControl]="frmAprovador" (selectionChange)="onChangeAprovador($event)" placeholder="APROVADOR" [required]="aprovadorIsRequired()">
                      <mat-select-filter *ngIf="aprovadorSelect.focused" [placeholder]="'Pesquisar...'" [array]="optionsAprovador" (filteredReturn)="filteredList1=$event" required></mat-select-filter>
                      <mat-option *ngFor="let item of filteredList1" [value]="item">
                        {{item}}
                      </mat-option>
                    </mat-select>
                    <mat-error *ngIf="formDir.submitted && aprovadorIsRequired()">Um aprovador válido deve ser selecionado
                    </mat-error>
                  </mat-form-field>
                  <mat-form-field fxFlex="25%">
                    <mat-select formControlName="frmResponsavel" (selectionChange)="onChangeResponsavel()" placeholder="Responsável" [(value)]="responsavelSelected" [disabled]="desabilitarResponsavel()">
                      <mat-option *ngFor="let responsavel of responsaveis" [value]="responsavel">
                        {{responsavel.nome}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
              </div>
              <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
                <mat-form-field *ngIf="protocolo.idTipoDocumento == 20">
                  <input [readonly]="apenasLeituraCFOP()" [required]="protocolo.idTipoDocumento == 20" (blur)="limparErrorsInput('frmCfop')" matInput placeholder="CFOP" formControlName="frmCfop" [(ngModel)]="protocolo.cfop" (change)="validarCfop(protocolo.cfop)" onlyNumbers maxlength="4">
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmCfop.errors && fFichaPro.frmCfop.errors.required">CFOP deve ser preenchido</mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="protocolo.idTipoDocumento == 20">
                  <mat-select formControlName="frmTipoFiscal" placeholder="TIPO FISCAL" [(ngModel)]="protocolo.idTipoFiscal" (selectionChange)="validarTipoFiscal($event)">
                    <mat-option *ngFor="let item of tipoFiscal" [value]="item.value">
                      {{item.viewValue}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

              </div>
              <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.0%">
                <mat-form-field fxFlex="25%">
                  <input [readonly]="apenasLeituraCNPJMRV()" (blur)="limparErrorsInput('frmCnpjEmpresa')" (input)="formatarCNPJEmpresaInput($event)" matInput formControlName="frmCnpjEmpresa" [(ngModel)]="protocolo.cnpjDestinatario" (change)="carregarEmpresaTomador()" placeholder="CNPJ DA EMPRESA MRV" maxlength="18" pattern="[A-Za-z0-9./-]*" required>
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmCnpjEmpresa.errors && fFichaPro.frmCnpjEmpresa.errors.required">{{getErrorCNPJMessage()}}
                  </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="25%">
                  <input matInput readonly formControlName="frmNomeEmpresa" (blur)="limparErrorsInput('frmNomeEmpresa')" [(ngModel)]="protocolo.nomeEmpresa" value="{{protocolo.nomeEmpresa}}" placeholder="NOME DA EMPRESA MRV" required>
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmNomeEmpresa.errors && fFichaPro.frmNomeEmpresa.errors.required">Empresa não cadastrada
                  </mat-error>
                </mat-form-field>

                <mat-form-field class="example-full-width" fxFlex="20%">

                    <input readonly formControlName="frmCentroLogistico" type="text" placeholder="CENTRO LOGÍSTICO" aria-label="Number" matInput [formControl]="frmCentroLogistico" [(ngModel)]="protocolo.centroLogistico" required>

                  <mat-error *ngIf="fFichaPro.frmCentroLogistico.errors && fFichaPro.frmCentroLogistico.errors.required">Um centro logistico válido deve ser selecionado</mat-error>
                  <mat-hint *ngIf="carregandoCentroLogistico">Carregando centro logistico, aguarde finalizar <img alt="Imagem load" src="assets/images/load32.gif" /></mat-hint>
                </mat-form-field>

                <div *ngIf="mostrarDivBuscaCentroLogistico()" class="divPesquisaCentroCusto" (click)="abrePopUpCentrosLogisticos()" fxFlex="4%">
                  <a class="linkPesquisaCentroCusto" mat-mini-fab>
                    <mat-icon class="iconPesquisa">search</mat-icon>
                  </a>
                </div>

                <mat-form-field fxFlex="20%">
                  <input type="text" [readonly]="apenasLeituraNumeroDocumento()" (blur)="limparErrorsInput('frmNumDocumento')" matInput placeholder="Nº DOCUMENTO" maxlength="9" pattern="[0-9]*" inputmode="numeric" formControlName="frmNumDocumento" [(ngModel)]="protocolo.documento" onlyNumbers required>
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmNumDocumento.errors && fFichaPro.frmNumDocumento.errors.required">Nº Documento é obrigatório
                  </mat-error>
                </mat-form-field>

                <mat-form-field fxFlex="10%">
                  <input [readonly]="apenasLeituraSerie()" matInput placeholder="SÉRIE" formControlName="frmSerie" [(ngModel)]="protocolo.serieNotaFiscal" value="{{protocolo.serieNotaFiscal}}" maxlength="3">
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmSerie.errors && fFichaPro.frmSerie.errors.required">Série é obrigatória</mat-error>
                </mat-form-field>
              </div>
              <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
                <mat-form-field>
                  <input [readonly]="apenasLeituraCNPJFornecedor()" (blur)="limparErrorsInput('frmCnpjFornecedor')" matInput formControlName="frmCnpjFornecedor" [(ngModel)]="protocolo.cnpjfornecedor" (change)="carregarFornecedor()" placeholder="CNPJ/CPF/CÓDIGO DO FORNECEDOR" maxlength="20" pattern="[A-Za-z0-9./-]*" required>
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmCnpjFornecedor.errors && fFichaPro.frmCnpjFornecedor.errors.required">{{getErrorCNPJMessage()}}
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input matInput readonly (blur)="limparErrorsInput('frmNomeFornecedor')" formControlName="frmNomeFornecedor" placeholder="NOME FORNECEDOR" [(ngModel)]="protocolo.nomeFornecedor" value={{fornecedor.nomeFornecedor}} required>
                  <mat-error *ngIf="!protocolo.nomeFornecedor && formDir.submitted">Fornecedor não cadastrado
                  </mat-error>
                </mat-form-field>
                <mat-form-field>
                  <input [readonly]="apenasLeituraDataEmissao()" (blur)="limparErrorsInput('frmDtEmissao')" matInput formControlName="frmDtEmissao" [matDatepickerFilter]="filterDataEmissao" (change)="validarDataEmissao($event)" (dateChange)="validarDataEmissao($event)" [(ngModel)]="protocolo.dataEmissaoNf" [matDatepicker]="picker" placeholder="EMISSÃO"
                    required #inputDataEmissao>
                  <span [class.visible-none]="apenasLeituraDataEmissao()" matSuffix class="calendar">
                    <mat-icon (click)="picker.open()">calendar_today</mat-icon>
                  </span>
                  <mat-datepicker #picker></mat-datepicker>
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmDtEmissao.errors && fFichaPro.frmDtEmissao.errors.required">A data de emissão é obrigatória
                  </mat-error>
                </mat-form-field>
                <mat-form-field [class.visible-none]="protocolo.idTipoFiscal == '10' || protocolo.idTipoFiscal == '30' || protocolo.idTipoFiscal == '40'">
                  <input (blur)="limparErrorsInput('frmVencimento')" matInput formControlName="frmVencimento"  (change)="validarDataVencimento($event)" (dateChange)="validarDataVencimento($event)" [(ngModel)]="protocolo.dataVencimentoNf" [matDatepicker]="picker1" placeholder="VENCIMENTO" [disabled]="apenasLeituraDataVencimento()"
                    [required]="dataVencimentoIsRequired()" #inputDataVencimento>
                  <span matSuffix class="calendar">
                    <mat-icon (click)="picker1.open()">calendar_today</mat-icon>
                  </span>
                  <mat-datepicker #picker1></mat-datepicker>
                  <mat-error *ngIf="formDir.submitted && dataVencimentoIsRequired() && fFichaPro.frmVencimento.errors && fFichaPro.frmVencimento.errors.required">A data de vencimento é obrigatória</mat-error>
                </mat-form-field>
              </div>
              <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
                <mat-slide-toggle fxFlex="25%" formControlName="frmParcelado" name="slideParcelado" [(ngModel)]="parcelado" [checked]="parcelado" (click)="onChangeParcelado()">PARCELADO</mat-slide-toggle>
                <mat-form-field fxFlex="24%" *ngIf="parcelado">
                  <mat-select formControlName="frmCondicaoPar" id="condicaoParcelamento" [(ngModel)]="protocolo.condicaoParcelamento" (optionSelected)="onChangeTipoDocumento($event)" (selectionChange)="onSelectedCondicaoParcelamento()" placeholder="CONDIÇÃO DE PARCELAMENTO"
                    required>
                    <mat-option *ngFor="let condicaoParc of condicoesParcelamento" [value]="condicaoParc.valor">
                      {{condicaoParc.nome}}
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="!parcelado">Uma condição de pagamento deve ser selecionada se a opção 'Parcelado' estiver marcado
                  </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="24%" *ngIf="!parcelado">
                  <input readonly formControlName="frmCondicaoPg" type="text" placeholder="CONDIÇÃO DE PAGAMENTO" matInput [formControl]="frmCondicaoPg" [(ngModel)]="protocolo.descricaoCondicaoPagamento">
                </mat-form-field>
                <mat-form-field fxFlex="24%" *ngIf="fornecedor.dataFixa && protocolo.dataVencimentoNf">
                  <input readonly formControlName="frmDataFixaPag" type="text" placeholder="DATA FIXA PAGAMENTO" matInput [formControl]="frmDataFixaPag" [(ngModel)]="protocolo.dataFixaPagamento">
                </mat-form-field>
              </div>
              <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
                <mat-form-field fxFlex="16%">
                  <span matPrefix>R$</span>
                  <input [readonly]="apenasLeituraValores()" (blur)="limparErrorsInput('frmValorTotalNf')" matInput placeholder="VALOR TOTAL DA NF" min="0" formControlName="frmValorTotalNf" [(ngModel)]="protocolo.valor" class="example-right-align" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" (blur)="this.atualizarValorTotalNota()" required>
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmValorTotalNf.hasError('valorTotalNfVazio')">
                    Valor total da NF deve ser preenchida
                  </mat-error>
                  <mat-error *ngIf="fFichaPro.frmValorTotalNf.errors && fFichaPro.frmValorTotalNf.errors.min">Valor total deve ser maior/igual à zero
                  </mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="protocolo.idTipoDocumento == 20 || protocolo.idTipoDocumento == 30" fxFlex="16%">
                  <span matPrefix>R$</span>
                  <input [readonly]="apenasLeituraValores()" matInput (blur)="limparErrorsInput('frmFrete')" placeholder="FRETE" min="0" formControlName="frmFrete" [(ngModel)]="protocolo.frete" class="example-right-align" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" (blur)="this.atualizarValorTotalNota()">
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmFrete.errors && fFichaPro.frmFrete.errors.required">Frete deve ser preenchido</mat-error>
                  <mat-error *ngIf="fFichaPro.frmFrete.errors && fFichaPro.frmFrete.errors.min">Frete deve ser maior/igual à zero
                  </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="16%">
                  <span matPrefix>R$</span>
                  <input [readonly]="apenasLeituraValores()" matInput (blur)="limparErrorsInput('frmDesconto')" placeholder="DESCONTO" min="0" formControlName="frmDesconto" [(ngModel)]="protocolo.desconto" class="example-right-align" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" (blur)="this.atualizarValorTotalNota()">
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmDesconto.errors && fFichaPro.frmDesconto.errors.required">Desconto deve ser preenchido
                  </mat-error>
                  <mat-error *ngIf="fFichaPro.frmDesconto.errors && fFichaPro.frmDesconto.errors.min">Desconto deve ser maior/igual à zero
                  </mat-error>
                </mat-form-field>
                <mat-form-field *ngIf="protocolo.idTipoDocumento == 20 || protocolo.idTipoDocumento == 30" fxFlex="16%">
                  <span matPrefix>R$</span>
                  <input [readonly]="apenasLeituraValores()" matInput (blur)="limparErrorsInput('frmValorTotalIpi')" min="0" placeholder="VALOR TOTAL IPI" formControlName="frmValorTotalIpi" [(ngModel)]="protocolo.valorIpi" class="example-right-align" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" (blur)="this.atualizarValorTotalNota()">
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmValorTotalIpi.errors && fFichaPro.frmValorTotalIpi.errors.required">Valor Total IPI deve ser preenchido
                  </mat-error>
                  <mat-error *ngIf="fFichaPro.frmValorTotalIpi.errors && fFichaPro.frmValorTotalIpi.errors.min">Valor total IPI deve ser maior/igual à zero
                  </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="16%">
                  <span matPrefix>R$</span>
                  <input [readonly]="apenasLeituraValores()" matInput (blur)="limparErrorsInput('frmValorSeguro')" min="0" placeholder="VALOR SEGURO" formControlName="frmValorSeguro" [(ngModel)]="protocolo.valorSeguro" class="example-right-align" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" (blur)="this.atualizarValorTotalNota()">
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmValorSeguro.errors && fFichaPro.frmValorSeguro.errors.required">Valor Seguro deve ser preenchido
                  </mat-error>
                  <mat-error *ngIf="fFichaPro.frmValorSeguro.errors && fFichaPro.frmValorSeguro.errors.min">Valor seguro IPI deve ser maior/igual à zero
                  </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="16%">
                  <span matPrefix>R$</span>
                  <input [readonly]="apenasLeituraValores()" matInput (blur)="limparErrorsInput('frmValorDespesas')" min="0" placeholder="OUTRAS DESPESAS" formControlName="frmValorDespesas" [(ngModel)]="protocolo.valorOutrasDespesas" class="example-right-align" currencyMask [options]="{ prefix: '', thousands: '.', decimal: ',' }" (blur)="this.atualizarValorTotalNota()">
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmValorDespesas.errors && fFichaPro.frmValorDespesas.errors.required">Valor Despesas deve ser preenchido
                  </mat-error>
                  <mat-error *ngIf="fFichaPro.frmValorDespesas.errors && fFichaPro.frmValorDespesas.errors.min">Valor despesas deve ser maior/igual à zero
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%" *ngIf='exibeMsgMesCorrente && exibeCondicaoPag'>
                <div>
                  O fornecimento do material ou serviço ocorreu no mesmo mês do faturamento?
                  <mat-radio-group aria-label="Select an option" id="mesCorrente" formControlName="frmMesCorrente" [(ngModel)]="protocolo.mesCorrente">
                    <mat-radio-button value="true" [checked]="protocolo.mesCorrente">Sim</mat-radio-button>
                    <mat-radio-button value="false">Não</mat-radio-button>
                  </mat-radio-group>
                </div>
              </div>


              <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
                <mat-form-field fxFlex="50%">
                  <input (blur)="limparErrorsInput('frmDescNota')"  matInput placeholder="DESCRIÇÃO DA NOTA" maxlength="250" formControlName="frmDescNota" [(ngModel)]="protocolo.observacao" value="{{protocolo.observacao}}" required>
                  <mat-error *ngIf="formDir.submitted && fFichaPro.frmDescNota.errors && fFichaPro.frmDescNota.errors.required">Descrição da nota é obrigatório
                  </mat-error>
                </mat-form-field>
                <mat-form-field fxFlex="25%" *ngIf="protocolo.modoEdicao">
                  <input readonly matInput formControlName="frmDataAlteracao" [(ngModel)]="protocolo.dataAlteracaoExibicao" placeholder="ÚLTIMA ALTERAÇÃO" disabled>
                  <span matSuffix class="calendar">
                    <mat-icon>calendar_today</mat-icon>
                  </span>
                  <mat-datepicker #pickerDataAlteracao></mat-datepicker>
                </mat-form-field>
                <mat-form-field fxFlex="25%" *ngIf="protocolo.modoEdicao">
                  <input readonly matInput formControlName="frmHoraAlteracao" [(ngModel)]="protocolo.horaAlteracaoExibicao" placeholder="HORA ÚLTIMA ALTERAÇÃO" disabled>
                </mat-form-field>
              </div>
              <div *ngIf="protocolo.motivoCancelamento" class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
                <mat-form-field fxFlex="50%">
                  <input matInput readonly placeholder="MOTIVO/OBSERVAÇÃO" maxlength="30" formControlName="frmMotivoCancelamento" [(ngModel)]="protocolo.motivoCancelamento" value="{{protocolo.motivoCancelamento}}">
                </mat-form-field>
              </div>
              <div class="container container-input" *ngIf="tipoOperacao !== 1" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
                <mat-form-field fxFlex="25%">
                  <input readonly matInput formControlName="frmDataCriacao" [(ngModel)]="protocolo.dataCriacaoExibicao" placeholder="DATA CRIAÇÃO" disabled>
                  <span matSuffix class="calendar">
                    <mat-icon>calendar_today</mat-icon>
                  </span>
                  <mat-datepicker></mat-datepicker>
                </mat-form-field>
                <mat-form-field fxFlex="25%">
                  <input readonly matInput formControlName="frmHoraCriacao" [(ngModel)]="protocolo.horaCriacaoExibicao" placeholder="HORA CRIAÇÃO" disabled>
                </mat-form-field>
                <mat-form-field fxFlex="25%">
                  <mat-select formControlName="frmCriadoPor" placeholder="Criado por" [(value)]="usuarioCriacao" disabled>
                    <mat-option *ngFor="let usuario of responsaveis" [value]="usuario">
                      {{usuario.nome}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
              <mat-action-row class="footer footer-ficha-protocolo">
                <div class="divValorTotal">
                  <span class="lbValorTotal">Valor Total dos Produtos: </span>
                  <span class="valorTotal">{{ protocolo.valorTotalComDescontos | currency: 'BRL' }}</span>
                </div>
                <button mat-button color="warn" (click)="voltar()">Voltar</button>
                <button mat-button color="primary" class="btn-primary" (keyup.enter)="onSubmitFicha()" (click)="onSubmitFicha()">CONTINUAR</button>
              </mat-action-row>
            </form>
          </mat-expansion-panel>

        <!--Fim Ficha Protocolo-->

        <!--Pedido-->
          <mat-expansion-panel *ngIf="exibeTelaPedidos()" class="expansion-panel" [expanded]="etapaAtual === 2" [disabled]="pedidoIsDisabled()" (opened)="pedidoInnit()">
            <mat-expansion-panel-header class="custom-header">
              <mat-panel-title>
                3. Pedidos
              </mat-panel-title>
            </mat-expansion-panel-header>
            <form [formGroup]="pedidosForm">
              <div *ngIf="tipoOperacao !== 2" class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
                <mat-form-field fxFlex="85%">
                  <input matInput formControlName="frmlistaPedidos" [(ngModel)]="numerosPedidos" placeholder="Informe os pedidos separados por vírgula">
                  <mat-error *ngIf="fPedido.frmlistaPedidos.errors && fPedido.frmlistaPedidos.errors.required">Lista de pedidos é obrigatoria
                  </mat-error>
                </mat-form-field>
                <div fxFlex="15%">
                  <button mat-button color="primary" style="padding: 0px;float: right;margin-top: 5px;" class="btn-primary" (click)="associarPedidos()">Associar Pedidos</button>
                </div>
              </div>
              <br />
              <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
                <div style="padding: 0px !important;">
                  <div class="table-container">
                    <table mat-table [dataSource]="dataSourcePedido">
                      <ng-container matColumnDef="codigoPedido">
                        <th mat-header-cell *matHeaderCellDef> N° Pedido </th>
                        <td mat-cell *matCellDef="let element"> {{element.codigoPedido}} </td>
                      </ng-container>
                      <ng-container matColumnDef="tipo">
                        <th mat-header-cell *matHeaderCellDef> Tipo </th>
                        <td mat-cell *matCellDef="let element"> {{element.tipo}} </td>
                      </ng-container>
                      <ng-container matColumnDef="dataLancamento">
                        <th mat-header-cell *matHeaderCellDef> Data Lançamento </th>
                        <td mat-cell *matCellDef="let element"> {{element.dataLancamento | date: 'dd/MM/yyyy'}} </td>
                      </ng-container>
                      <ng-container matColumnDef="loginUsuarioLancamento">
                        <th mat-header-cell *matHeaderCellDef> Usuário Lançamento </th>
                        <td mat-cell *matCellDef="let element"> {{ element.loginUsuarioLancamento }}</td>
                      </ng-container>
                      <ng-container matColumnDef="valorTotal">
                        <th mat-header-cell *matHeaderCellDef> Valor </th>
                        <td mat-cell *matCellDef="let element"> {{element.valorTotal | currency: 'BRL' }} </td>
                      </ng-container>
                      <ng-container matColumnDef="acoes">
                        <th mat-header-cell *matHeaderCellDef style="width: 5%"> Ações </th>
                        <td mat-cell *matCellDef="let element; let index = index">
                          <a style="color:red" [class.disabled-action]="desabilitarExclusaoPedido()" (click)="deleteRowPedido(element)">
                            <mat-icon class="calendar">delete</mat-icon>
                          </a>
                        </td>
                      </ng-container>
                      <tr mat-header-row *matHeaderRowDef="displayedColumnsPedido"></tr>
                      <tr mat-row *matRowDef="let row; columns: displayedColumnsPedido;"></tr>
                    </table>
                  </div>
                  <mat-paginator #pedidoPaginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
                </div>
              </div>

            <br />
            <div class="container container-input md-button-right" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
              <div fxFlex="100%">
                <label style="font-weight: 500;" class="align-rigth colored-gray">VALOR TOTAL DOS PEDIDOS (R$):
                  {{ obterValorTotalPedidosComArredondamento() | currency:'BRL':true:'1.2-4'}}</label>
              </div>
            </div>

              <br />
              <mat-action-row class="footer">
                <button mat-button color="warn" (click)="voltar()">Voltar</button>
                <a mat-button color="primary" class="btn-primary" (keyup.enter)="onSubmitPedido()" (click)="onSubmitPedido()">CONTINUAR</a>
              </mat-action-row>
            </form>
          </mat-expansion-panel>
        <!--Fim Pedido-->

        <!--Produto-->
        <mat-expansion-panel class="expansion-panel" [expanded]="etapaAtual === 3" [disabled]="produtoIsDisabled()" (opened)="produtoInnit()">
          <mat-expansion-panel-header class="custom-header">
            <mat-panel-title>
              4. Produtos/Serviços
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="produtosForm">
            <br />
            <p>
              <label class="mat-h2">
                Valor Total dos Produtos da NF:
                <span style="color: green;"> {{ protocolo.valorTotalComDescontos | currency: 'BRL' }}</span>
              </label>
            </p>
            <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
              <div style="padding: 0px !important;">
                <button mat-button color="primary" style="padding: 0px;float: left;margin-top: 5px;margin-bottom: 15px;" class="btn-primary" (click)="abrirModalProduto()" *ngIf="permiteEditarProdutos && tipoOperacao !== 2 && protocolo.codEmpresa !== 'FKIT'">
                    Adicionar
                </button>
              </div>
            </div>
            <ng-container formArrayName="produtosArray">
              <div class="table-container">
                <table mat-table [dataSource]="dataSourceProdutos" matSort style="width:100%;" #tableProdutos>
                  <ng-container matColumnDef="item-produto">
                    <th mat-header-cell *matHeaderCellDef style="padding: 5px"> Item </th>
                    <td mat-cell *matCellDef="let element; let index = index" style="padding: 0"> {{ (produtoPaginator.pageIndex * produtoPaginator.pageSize) + index + 1 }} </td>
                  </ng-container>

                  <ng-container matColumnDef="cnae-produto">
                    <th mat-header-cell *matHeaderCellDef> CNAE/NCM </th>
                    <td mat-cell *matCellDef="let element; let index = index"> {{element.cnae}} </td>
                  </ng-container>

                  <ng-container matColumnDef="idSapProduto-produto">
                    <th mat-header-cell *matHeaderCellDef> Material </th>
                    <td mat-cell *matCellDef="let element; let index = index"> {{element.idSapProdutoFormated}} </td>
                  </ng-container>

                  <ng-container matColumnDef="descricao-produto">
                    <th mat-header-cell *matHeaderCellDef> Descrição </th>
                    <td mat-cell *matCellDef="let element; let index = index"> {{ element.descricao }}</td>
                  </ng-container>

                  <ng-container matColumnDef="unidade-produto">
                    <th mat-header-cell *matHeaderCellDef> UN </th>
                    <td mat-cell *matCellDef="let element; let index = index"> {{element.unidade}} </td>
                  </ng-container>

                  <ng-container matColumnDef="quantidade-produto">
                    <th mat-header-cell *matHeaderCellDef> Qtde </th>
                    <td mat-cell *matCellDef="let element; let index = index" [formGroupName]="index">
                      <mat-form-field>
                        <input [readonly]="tipoOperacao === 2" matInput id="quantidade" name="quantidade" onlyNumberWithDecimal [(ngModel)]="element.quantidadeFormated" formControlName="frmQuantidade" (blur)="calcularValorTotal(element)">
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="valorUnitario-produto">
                    <th mat-header-cell *matHeaderCellDef> Valor (R$) </th>
                    <td mat-cell *matCellDef="let element; let index = index" [formGroupName]="index">
                      <mat-form-field class="input-full-width">
                        <span matPrefix>R$</span>
                        <input matInput formControlName="frmValor" currencyMask id="valorUnitario" [(ngModel)]="element.valorUnitario" name="valorUnitario" [options]="{ prefix: '', thousands: '.', decimal: ',' }" [readonly]="tipoOperacao === 2 || pedidoPreexistente" (blur)="calcularValorTotal(element)">
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="valorTotal-produto">
                    <th mat-header-cell *matHeaderCellDef> Total (R$) </th>
                    <td mat-cell *matCellDef="let element; let index = index">
                      {{element.valorTotal | currency:'BRL':true:'1.2-4'}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="aliquotaIPI-produto">
                    <th mat-header-cell *matHeaderCellDef> Aliquota IPI (%) </th>
                    <td mat-cell *matCellDef="let element; let index = index" [formGroupName]="index">
                      <mat-form-field>
                        <input [readonly]="!permiteEditarAliquota" matInput id="aliquotaIPI" name="aliquotaIPI" onlyNumberWithDecimal [(ngModel)]="element.aliquotaIPI" formControlName="frmaliquotaIPI" (blur)="calcularValorTotal(element)">
                      </mat-form-field>
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="ipi-produto">
                    <th mat-header-cell *matHeaderCellDef> Valor IPI </th>
                    <td mat-cell *matCellDef="let element; let index = index">
                      {{element.ipi | currency:'BRL':true:'1.2-4'}}
                    </td>
                  </ng-container>

                  <ng-container matColumnDef="contaContabil-produto">
                    <th mat-header-cell *matHeaderCellDef> CC </th>
                    <td mat-cell *matCellDef="let element; let index = index"> {{element.contaContabil}} </td>
                  </ng-container>

                  <ng-container matColumnDef="idSapPedidoContrato-produto">
                    <th mat-header-cell *matHeaderCellDef> Pedido </th>
                    <td mat-cell *matCellDef="let element; let index = index"> {{element.idSapPedidoContrato}} </td>
                  </ng-container>

                  <ng-container matColumnDef="acoes-produto">
                    <th mat-header-cell *matHeaderCellDef style="padding: 5px"> Ações </th>
                    <td mat-cell *matCellDef="let element; let index = index" style="padding: 0">
                      <button mat-icon-button [class.disabled-action]="desabilitarExclusaoProduto()" (click)="deleteRowProduto(element)" aria-label="Deleção de produto">
                      <mat-icon class="calendar">delete</mat-icon>
                    </button>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="displayedColumnsProduto"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumnsProduto;"></tr>
                </table>
              </div>
              <mat-paginator #produtoPaginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
            </ng-container>

            <mat-form-field style="width: 100%;" *ngIf="protocolo.idTipoFiscal != '10' && protocolo.produtos.length > 0 && !pedidoPreexistente && protocolo.idTipoDocumento !== 70 ">
              <mat-select formControlName="justificativa" [required]="justificativaIsRequired()" placeholder="Por quê o Pedido não foi criado antes da emissão da Nota Fiscal?" maxlength="255" [(ngModel)]="protocolo.justificativa">
                <mat-option *ngFor="let item of justificativas" [value]="item.value">
                  {{item.viewValue}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="fProduto.justificativa.errors && fProduto.justificativa.errors.required">Justificativa deve ser preenchida!</mat-error>
            </mat-form-field>

            <br />
            <div class="container container-input md-button-right" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
              <div fxFlex="100%">
                <label style="font-weight: 500;" class="align-rigth colored-gray">VALOR TOTAL DOS PRODUTOS (R$):
                  {{ obterValorTotalProdutosComArredondamento() | currency:'BRL':true:'1.2-4'}}</label>
              </div>
            </div>

            <br />
            <mat-action-row class="footer" *ngIf="dataSourceProdutos.data.length !== 0">
              <button mat-button color="warn" (click)="voltar()">Voltar</button>
              <a mat-button color="primary" class="btn-primary" (keyup.enter)="onSubmitProdutos()" (click)="onSubmitProdutos()">CONTINUAR</a>
            </mat-action-row>
          </form>
        </mat-expansion-panel>
        <!--Fim Produto-->
        <!-- Medições -->
        <mat-expansion-panel class="expansion-panel" [disabled]="medicaoIsDisabled()" [expanded]="etapaAtual === 4" *ngIf="dataSourceMedicao.data.length !== 0" (opened)="Medicoesinnit()">
          <mat-expansion-panel-header class="custom-header">
            <mat-panel-title>
              4.1 Medições
            </mat-panel-title>
          </mat-expansion-panel-header >

          <div class="divBtnExpandir" *ngIf="dataSourceProdutos.data.length !== 0">
            <a mat-button [style.background-color]="botaoExpandirMedicaoCor" class="btnExpandirMedicao" (click)="expandirContrairTabelaMedicao()">{{ botaoExpandirMedicaoTexto }}</a>
          </div>

          <div class="table-container" style="margin-top: 2vh;">
            <table mat-table [dataSource]="dataSourceMedicao" multiTemplateDataRows class="mat-elevation-z8">
              <ng-container matColumnDef="checkBox">
                <th mat-header-cell *matHeaderCellDef>
                  <mat-checkbox (change)="$event ? toggleAllRows() : null"
                                [checked]="selectionMedicao.hasValue() && isAllSelectedMedicao()"
                                [indeterminate]="selectionMedicao.hasValue() && !isAllSelectedMedicao()"
                                [disabled]="this.tipoOperacao === 2"
                                [ngClass]="{ 'disabled-checkbox': this.tipoOperacao === 2 }"
                                >
                  </mat-checkbox>
                </th>
                <td mat-cell *matCellDef="let element">
                  <mat-checkbox [disabled]="desabilitarCheckMedicao(element)"
                                (click)="$event.stopPropagation()"
                                (change)="selecionarItemMedicao(element)"
                                [checked]="selectionMedicao.isSelected(element)"
                                [ngClass]="{ 'disabled-checkbox': element.aceite === false || this.tipoOperacao === 2 }">
                  </mat-checkbox>
                </td>
              </ng-container>
              <ng-container matColumnDef="idMedicaoAssociada">
                <th mat-header-cell *matHeaderCellDef> Medição </th>
                <td mat-cell *matCellDef="let element"><span [ngClass]="{ 'disabled-checkbox': desabilitarCheckMedicao(element) }" >{{element.codigoMedicao}}</span></td>
              </ng-container>
              <ng-container matColumnDef="codigoItemPedido">
                <th mat-header-cell *matHeaderCellDef> Item/Pedido </th>
                <td mat-cell *matCellDef="let element"> <span [ngClass]="{ 'disabled-checkbox': desabilitarCheckMedicao(element) }" >{{element.codigoItemPedido}}</span></td>
              </ng-container>
              <ng-container matColumnDef="valorTotal-medicao">
                <th mat-header-cell *matHeaderCellDef> Valor Total</th>
                <td mat-cell *matCellDef="let element"> <span [ngClass]="{ 'disabled-checkbox': desabilitarCheckMedicao(element) }" >{{element.valorTotal | currency:'BRL':true:'1.2-4'}}</span></td>
              </ng-container>
              <ng-container matColumnDef="acoes-medicao">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element">
                  <mat-icon>keyboard_arrow_down</mat-icon>
                </td>
              </ng-container>

              <ng-container matColumnDef="expandedDetail">
                <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumnsMedicao.length">
                  <div class="example-element-detail" [@detailExpand]="expandedElement ? 'collapsed' : 'expanded' " [ngClass]="{ 'disabled-checkbox': desabilitarCheckMedicao(element) }">
                      <tr>
                        <th>Código Serviço</th>
                        <td *ngFor="let item of element.Elements">{{item.codigoServico}}</td>
                      </tr>
                      <tr>
                        <th>Descrição</th>
                        <td *ngFor="let item of element.Elements">{{item.descricao}}</td>
                      </tr>
                      <tr>
                        <th>Unidade</th>
                        <td *ngFor="let item of element.Elements">{{item.unidade}}</td>
                      </tr>
                      <tr>
                        <th>Quantidade</th>
                        <td *ngFor="let item of element.Elements">{{item.quantidade}}</td>
                      </tr>
                      <tr>
                        <th>Valor Unitário</th>
                        <td *ngFor="let item of element.Elements">{{item.valorUnitario | currency:'BRL':true:'1.2-4'}}</td>
                      </tr>
                  </div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumnsMedicao"></tr>
              <tr mat-row *matRowDef="let element; columns: displayedColumnsMedicao;" class="example-element-row"
                [class.example-expanded-row]="expandedElement === element">
              </tr>
              <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
            </table>
          </div>
          <mat-paginator #medicaoPaginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
          <br/>
          <div class="container container-input md-button-right" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
            <div fxFlex="70%" style="padding-right: 70px">
              <label class="align-rigth label colored-gray" style="width:250px !important;">A SEREM MEDIDOS (R$):
                {{ obterValorTotalParaSerMedido() | currency:'BRL':true:'1.2-4'}}</label>
            </div>
            <div fxFlex="30%">
              <label style="font-weight: 500;" class="align-rigth colored-gray">TOTAL MEDIDO (R$): {{ obterValorTotalMedicoesComArredondamento() | currency:'BRL':true:'1.2-4'}}</label>
            </div>
          </div>
          <mat-action-row class="footer-medicoes" *ngIf="dataSourceProdutos.data.length !== 0">
            <button mat-button color="warn" (click)="voltar()">Voltar</button>
            <a mat-button color="primary" class="btn-primary" (keyup.enter)="onSubmitMedicoes()" (click)="onSubmitMedicoes()">CONTINUAR</a>
          </mat-action-row>
        </mat-expansion-panel>
        <!-- Fim Medições -->
        <!--Rateio-->
        <mat-expansion-panel *ngIf="exibirEtapaRateio()" class="expansion-panel" [disabled]="rateioIsDisabled()" [expanded]="etapaAtual === 5" (opened)="rateioInnit()">
          <mat-expansion-panel-header class="custom-header">
            <mat-panel-title>
              5. Rateio
            </mat-panel-title>
          </mat-expansion-panel-header>
          <form [formGroup]="rateioDespesasForm">
            <div *ngIf="tipoOperacao !== 2 && !pedidoPreexistente" class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
              <mat-form-field fxFlex="25%">
                  <mat-select formControlName="frmItem" [(value)]="produtoSelected" placeholder="Produtos / Serviços">
                    <mat-option *ngFor="let tpItem of protocolo.produtos; let i = index;" [value]="tpItem" [disabled]="this.verificaItemTodos()">
                    {{i+1}} - {{tpItem.descricao}}
                    </mat-option>
                    <mat-option [value]="itemRateioTodos" > Todos itens </mat-option>
                  </mat-select>
                </mat-form-field>
              <mat-form-field fxFlex="25%">
                <mat-select formControlName="frmTipoColetor" id="nomeTipoColetor" [(ngModel)]="rateioAdicionado.codTipoColetor" placeholder="Tipo de coletor" (selectionChange)="verificaDiagramaDeRede()">
                  <mat-option value="N">N - Diagrama de rede</mat-option>
                  <mat-option value="K">K - Centro de custo</mat-option>
                  <mat-option value="F">F - Ordem Interna</mat-option>
                  <mat-option value="A">A - Imobilizado</mat-option>
                  <mat-option value="F">F - Ordem de Manutenção</mat-option>
                </mat-select>
                <mat-error *ngIf="fRateio.frmTipoColetor.errors && fRateio.frmTipoColetor.errors.required">Um tipo de coletor deve ser selecionado</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="23%">
                <input matInput formControlName="frmColetorCustos" [(ngModel)]="rateioAdicionado.identificacaoColetor" value="{{rateioAdicionado.identificacaoColetor}}" placeholder="Coletor de Custos">
                <mat-error *ngIf="fRateio.frmColetorCustos.errors && fRateio.frmColetorCustos.errors.required">Coletor de custos obrigatório</mat-error>
                <mat-error *ngIf="rateioDespesasForm.get('frmColetorCustos').hasError('erroTipoRateioValidacao')">{{rateioDespesasForm.get('frmColetorCustos').errors.erroTipoRateioValidacao}}</mat-error>
              </mat-form-field>
              <div fxFlex="4%">
                <a class="linkPesquisa" mat-mini-fab (click)="pesquisarColetorCustos()" *ngIf="pesColetorCustos">
                  <mat-icon class="iconPesquisa">search</mat-icon>
                </a>
              </div>
              <mat-form-field fxFlex="23%">
                <input matInput formControlName="frmNumOperacao" [(ngModel)]="rateioAdicionado.operacaoSubNumero" placeholder="N. da operação">
                <mat-error *ngIf="fRateio.frmNumOperacao.hasError('maxlength') || diagramaDeRede">{{getErrorMessageNumOperacao()}}</mat-error>
              </mat-form-field>
            </div>
            <div *ngIf="tipoOperacao !== 2 && !pedidoPreexistente" class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
              <mat-form-field fxFlex="25%">
                <input matInput formControlName="frmValorDespesa" [(ngModel)]="rateioAdicionado.valor" placeholder="Valor" class="example-right-align" currencyMask [options]="{ prefix: 'R$ ', thousands: '.', decimal: ',' }">
                <mat-error *ngIf="fRateio.frmValorDespesa.errors && fRateio.frmValorDespesa.errors.required">É necessario um valor</mat-error>
              </mat-form-field>
              <mat-form-field fxFlex="65%">
                <input matInput formControlName="frmDescricaoDespesa" [(ngModel)]="rateioAdicionado.descricao" value="{{rateioAdicionado.descricao}}" maxlength="250" placeholder="Descrição">
                <mat-error *ngIf="fRateio.frmDescricaoDespesa.errors && fRateio.frmDescricaoDespesa.errors.required">A descrição é obrigatório</mat-error>
              </mat-form-field>
              <div fxFlex="15%">
                <button mat-button color="primary" style="float: right;margin-top: 5px;" class="btn-primary" (click)="incluirRateioTabela()">INCLUIR</button>
              </div>
            </div>
            <app-planilha-fiscal *ngIf="exibirCampoPlanilhaFiscal()"></app-planilha-fiscal>
            <br />
          </form>
          <form>
            <div class="container container-input" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
              <div style="padding: 0px !important;">
                <div>
                  <mat-form-field>
                    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtrar">
                  </mat-form-field>
                </div>
                <div class="table-container">
                  <table mat-table [dataSource]="dataSourceRateio">
                    <ng-container matColumnDef="item">
                      <th mat-header-cell *matHeaderCellDef> Item </th>
                      <td mat-cell *matCellDef="let element"> {{!(element.item) || element.item == '0'? 'Todos' : element.item}} </td>
                    </ng-container>

                    <ng-container matColumnDef="numeroSerial">
                      <th mat-header-cell *matHeaderCellDef> Número serial </th>
                      <td mat-cell *matCellDef="let element"> {{element.numeroSerial}} </td>
                    </ng-container>

                    <ng-container matColumnDef="tipoColetor">
                      <th mat-header-cell *matHeaderCellDef> Tipo de coletor </th>
                      <td mat-cell *matCellDef="let element"> {{element.codTipoColetor}} </td>
                    </ng-container>

                    <ng-container matColumnDef="coletorCusto">
                      <th mat-header-cell *matHeaderCellDef> Coletor de Custo </th>
                      <td mat-cell *matCellDef="let element"> {{element.identificacaoColetor}} </td>
                    </ng-container>

                    <ng-container matColumnDef="numeroOperacao">
                      <th mat-header-cell *matHeaderCellDef> Nº da Operação </th>
                      <td mat-cell *matCellDef="let element"> {{ element.operacaoSubNumero }}</td>
                    </ng-container>

                    <ng-container matColumnDef="descricao">
                      <th mat-header-cell *matHeaderCellDef> Descrição </th>
                      <td mat-cell *matCellDef="let element"> {{element.descricao}} </td>
                    </ng-container>

                    <ng-container matColumnDef="valor">
                      <th mat-header-cell *matHeaderCellDef> Valor </th>
                      <td mat-cell *matCellDef="let element"> {{element.valor | currency:'BRL':true:'1.2-4'}} </td>
                    </ng-container>

                    <ng-container matColumnDef="idSapPedidoContrato">
                      <th mat-header-cell *matHeaderCellDef> Pedido </th>
                      <td mat-cell *matCellDef="let element"> {{element.idSapPedidoContrato}} </td>
                    </ng-container>

                    <ng-container matColumnDef="select">
                      <th mat-header-cell *matHeaderCellDef>
                        <div *ngIf="!possuiPedidoAssociado">
                          <mat-icon class="deleteIconRateio" [class.disabled-action]="desabilitarExclusaoRateio()" (click)="deleteAllRowsRateio()">delete</mat-icon>
                        </div>
                      </th>
                      <td mat-cell *matCellDef="let row">
                        <div *ngIf="!possuiPedidoAssociado">
                          <mat-icon class="deleteIconRateio" [class.disabled-action]="desabilitarExclusaoRateio()" (click)="deleteRowRateio(row.item, row.numeroSerial)">delete</mat-icon>
                        </div>
                      </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumnsRateio"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumnsRateio;"></tr>
                  </table>
                </div>
                <mat-paginator #rateioPaginator [pageSizeOptions]="[5, 50, 100, 500, 1000]" showFirstLastButtons></mat-paginator>
              </div>
            </div>
            <br />

            <div class="container container-input md-button-right" fxLayout="row" fxLayout.xs="column" fxLayoutGap="0.5%">
              <div fxFlex="70%" style="padding-right: 70px">
                <label class="align-rigth label colored-gray" style="width:250px !important;">A SEREM RATEADOS (R$):
                  {{ obterValorTotalParaSerRateado() | currency:'BRL':true:'1.2-4'}}</label>
              </div>
              <div fxFlex="30%">
                <label style="font-weight: 500;" class="align-rigth colored-gray">TOTAL RATEADO (R$): {{ obterValorTotalRateiosComArredondamento() | currency:'BRL':true:'1.2-4'}}</label>
              </div>
            </div>

            <mat-action-row class="footer">
              <button mat-button color="warn" (click)="voltar()">Voltar</button>
            </mat-action-row>
          </form>
        </mat-expansion-panel>
        <!--Fim Rateio-->
      </mat-accordion>
    </div>
  </div>
  <app-footer></app-footer>
</div>
